import React, { useState, useEffect } from 'react';
import { getApi } from '../api/endpoints';
import { Card, Row, Col } from 'react-bootstrap';

const CustomerStats = () => {
  return <div className="customer-stats mb-3">
  </div>
}

export default CustomerStats;
